import { Component,Inject,OnInit,PLATFORM_ID,Renderer2,TemplateRef,ViewChild } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup } from '@angular/forms';
import { FormBuilder,Validators } from '@angular/forms';
import { MainserviceService } from 'src/app/mainservice.service';
import Swal from 'sweetalert2';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { JsonLdService, SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
@Component({
  selector: 'app-generalveterinary',
  templateUrl: './generalveterinary.component.html',
  styleUrls: ['./generalveterinary.component.scss'],
  providers:[MainserviceService,DatePipe]
})
export class GeneralveterinaryComponent {
  enquiryForm:FormGroup;
  totalcountry:any=[];
  captcha:any
  errorcaptcha:any
  ecaptcha:boolean=false;
  dialcode:any;
  showElement: boolean = false;
  showElementsave: boolean = false;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild('inputField') inputField!: any;
  currentTime: Date;
  timeSlots:any=[];
  timezone:any;
  appointment_time:boolean=false;
  selectedTime: string | null = null;
  leads:any;
constructor(private ngxsmartservice:NgxSmartModalService,private fb:FormBuilder,private seoService: SeoSocialShareService,private jsonLdService: JsonLdService,
  private mainservice:MainserviceService,private datePipe: DatePipe,private title:Title,private meta:Meta,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: Object){
    if (isPlatformBrowser(this.platformId)) {
    this.setSeoMeta();
    this.setSchema();
    this.setFaqSchemaData();
    this. setWebsiteSchema();
    // this.title.setTitle('Transform Your Veterinary & Pet Store Management');

    // // Add meta tags dynamically
    // this.meta.addTag({ name: 'description', content: 'Streamline operations, boost ROI. Automate processes for success. Transform your pet business with automated processes. Maximize ROI today!'});
    // this.meta.updateTag({ name: 'keywords', content: 'veterinary software, pet store software, vet software, cloud based veterinary software, veterinary computer software' });
  this.timezone=sessionStorage.getItem('timezone');
  this.enquiryForm=this.fb.group({
      leadname: ['',[ Validators.required]],
      organizationname: ['',[Validators.required]],
      leadsourceid: ['',[]],
      leadsource: ['medeil website',[]],
      sourceRef1: ['',[]],
      sourceRef2: ['',[]],
      description: ['',[ Validators.required]],
      primaryphone: ['',[Validators.required]],
      primaryemail: ['',[Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
      address1: ['',[]],
      address2: ['',[]],
      country: [sessionStorage.getItem('country'),[],[]],
      countryname1: ['0',[]],
      state: [sessionStorage.getItem('state'),[]],
      city: [sessionStorage.getItem('city'),[]],
      enteredcaptcha: ['',[]],
      generatedcaptcha: ['',[]],
      phonedialcode:['',[]],
      checkbox:[false,[]],
      appfrmtime:['',[]],
      apptotime:['',[]],
      appointmentdate:['',[]],
    })
  }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
    this.mainservice.generatecaptcha();
    this.captcha = localStorage.getItem('captcha')
     // ----country list--
     this.mainservice.getCountryList().subscribe(data=>{
       console.log(data);
       this.totalcountry=data;
     })
    }
  }
  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: 'Veterinary Store Software | Efficient Management for Veterinary Retail',
  //     description: 'Streamline your veterinary store operations with Medeil\'s software. Manage inventory, prescriptions, and sales with ease.',
  //     image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.pngg',
  //     url: 'https://www.medeil.com/industry/veterinary-software',
  //     keywords: 'Veterinary store software, veterinary inventory management, veterinary POS system, pet store software, veterinary retail software.'
  //   };

  //   this.seoService.setData(seoData);
  // }
  // setWebsiteSchema() {
  //   const schemawebData = {
  //     "@context": "https://schema.org",
  //     "@type": "WebSite",
  //     "name": "Medeil Veterinary Store Software",
  //     "url": "https://www.medeil.com",
  //     "description": "Medeil provides advanced veterinary and pharmacy management software solutions. Explore our innovative tools for veterinary stores, pharmacies, and pet healthcare businesses.",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //     "publisher": {
  //       "@type": "Organization",
  //       "name": "Medeil",
  //       "url": "https://www.medeil.com",
  //       "logo": {
  //         "@type": "ImageObject",
  //         "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
  //       }
  //     }
  //   };

  //   this.jsonLdService.setData(schemawebData);
  // }

  // setSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "SoftwareApplication",
  //     "name": "Medeil Veterinary Store Software",
  //     "url": "https://www.medeil.com/industry/veterinary-software",
  //     "description": "Streamline your veterinary store operations with Medeil's software. Manage inventory, prescriptions, and sales with ease.",
  //     "applicationCategory": "BusinessApplication",
  //     "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.pngg",
  //     "offers": {
  //       "@type": "Offer",
  //       "priceCurrency": "USD",
  //       "availability": "https://schema.org/InStock",
  //       "url": "https://www.medeil.com/industry/veterinary-software",
  //       "keywords": "Veterinary store software, veterinary inventory management, veterinary POS system, pet store software, veterinary retail software."
  //     },
  //     "aggregateRating": {
  //       "@type": "AggregateRating",
  //       "ratingValue": "4.6",
  //       "ratingCount": "8864"
  //     },
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }
  // setFaqSchemaData() {
  //   const faqSchema = {
  //     "@context": "https://schema.org",
  //     "@type": "FAQPage",
  //     "mainEntity": [
  //       {
  //         "@type": "Question",
  //         "name": "Which kinds of drugs and supplies do you provide for animals?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Consumers frequently inquire about the variety of drugs and supplies that are offered for different kinds of animals, such as over-the-counter vitamins, prescription drugs, vaccinations, and specialized goods like veterinary diets and compounded drugs."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "How can your Veterinary software improve clinic operations efficiency?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "This inquiry pertains to the MEDEILCloud POS & HQ software's advantages in terms of productivity and efficiency. Features like inventory tracking, appointment scheduling, electronic health record management, and automated billing procedures that save administrative work and boost workflow efficiency could be among the solutions."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Can your software be tailored to meet the unique requirements of our Pet pharmacy & clinic?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "This inquiry looks for details regarding the software's versatility and customization options. Information on user interfaces, workflow configurations, and templates that can be customized to a clinic's specific needs and preferences may be included in the answers."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "What type of assistance and training are available for setting up and utilising the software?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "This inquiry relates to the software vendor's support and training offerings. In addition to providing clinics with access to instructional materials, webinars, and individualized support from a dedicated support team, the answers should outline the training resources, onboarding aid, and continuing support choices available to assist clinics in successfully implementing and using the software."
  //         }
  //       }
  //     ]
  //   };

  //   this.addJsonLdToHead(faqSchema);
  // }


  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: $localize`:@@VETERINARY_STORE.SOFTWARE_TITLE:Veterinary Store Software | Efficient Management for Veterinary Retail`,
  //     description: $localize`:@@VETERINARY_STORE.SOFTWARE_DESCRIPTION:Streamline your veterinary store operations with Medeil's software. Manage inventory, prescriptions, and sales with ease.`,
  //     image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
  //     url: 'https://www.medeil.com/industry/veterinary-software',
  //     keywords: $localize`:@@VETERINARY_STORE.SOFTWARE_KEYWORDS:Veterinary store software, veterinary inventory management, veterinary POS system, pet store software, veterinary retail software.`
  //   };

  //   this.seoService.setData(seoData);
  // }
  setSeoMeta() {
      const supportedLanguages = ['en', 'fr', 'es', 'pt'];
      let finalUrl = '';

      if (isPlatformBrowser(this.platformId)) {
        const origin = window.location.origin;
        const path = window.location.pathname;
        const parts = path.split('/');

        let lang = 'en'; // Default
        if (supportedLanguages.includes(parts[1])) {
          lang = parts[1];
        }

        // const fullPath = path.replace(/^\/[a-z]{2}/, '');
        // finalUrl = `${origin}/${lang}${fullPath}`;
        const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

      }

    const seoData = {
      title: $localize`:@@VETERINARY_STORE.SOFTWARE_TITLE:Veterinary Software for Retail Management`,
      description: $localize`:@@VETERINARY_STORE.SOFTWARE_DESCRIPTION:Manage veterinary store operations with Medeil software—inventory, prescriptions, and sales made simple.`,
      image: 'https://www.medeil.com/en/assets/img/logo/medeil_logo_1.png',
      url: finalUrl,
      keywords: $localize`:@@VETERINARY_STORE.SOFTWARE_KEYWORDS:Veterinary store software, veterinary inventory management, veterinary POS system, pet store software, veterinary retail software.`
    };

    this.title.setTitle(seoData.title);
    const metaTags = [
      { name: 'description', content: seoData.description },
      { name: 'keywords', content: seoData.keywords },
      { property: 'og:title', content: seoData.title },
      { property: 'og:description', content: seoData.description },
      { property: 'og:url', content: seoData.url },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: seoData.image }
    ];

    metaTags.forEach(tag => this.meta.updateTag(tag));
  }
  setWebsiteSchema() {
    const schemawebData = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": $localize`:@@VETERINARY_STORE.WEBSITE_NAME:Medeil Veterinary Store Software`,
      "url": "https://www.medeil.com",
      "description": $localize`:@@VETERINARY_STORE.WEBSITE_DESCRIPTION:Medeil provides advanced veterinary and pharmacy management software solutions. Explore our innovative tools for veterinary stores, pharmacies, and pet healthcare businesses.`,
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "publisher": {
        "@type": "Organization",
        "name": "Medeil",
        "url": "https://www.medeil.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
        }
      }
    };

    this.jsonLdService.setData(schemawebData);
  }

  setSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": $localize`:@@VETERINARY_STORE.SCHEMA_NAME:Medeil Veterinary Store Software`,
      "url": "https://www.medeil.com/industry/veterinary-software",
      "description": $localize`:@@VETERINARY_STORE.SCHEMA_DESCRIPTION:Streamline your veterinary store operations with Medeil's software. Manage inventory, prescriptions, and sales with ease.`,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "offers": {
        "@type": "Offer",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock",
        "url": "https://www.medeil.com/industry/veterinary-software",
        "keywords": $localize`:@@VETERINARY_STORE.SCHEMA_KEYWORDS:Veterinary store software, veterinary inventory management, veterinary POS system, pet store software, veterinary retail software.`
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.6",
        "ratingCount": "8864"
      }
    };

    this.jsonLdService.setData(schemaData);
  }
  setFaqSchemaData() {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": $localize`:@@VETERINARY_STORE.QUESTION_1:Which kinds of drugs and supplies do you provide for animals?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@VETERINARY_STORE.ANSWER_1:Consumers frequently inquire about the variety of drugs and supplies that are offered for different kinds of animals, such as over-the-counter vitamins, prescription drugs, vaccinations, and specialized goods like veterinary diets and compounded drugs.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@VETERINARY_STORE.QUESTION_2:How can your Veterinary software improve clinic operations efficiency?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@VETERINARY_STORE.ANSWER_2:This inquiry pertains to the MEDEILCloud POS & HQ software's advantages in terms of productivity and efficiency. Features like inventory tracking, appointment scheduling, electronic health record management, and automated billing procedures that save administrative work and boost workflow efficiency could be among the solutions.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@VETERINARY_STORE.QUESTION_3:Can your software be tailored to meet the unique requirements of our Pet pharmacy & clinic?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@VETERINARY_STORE.ANSWER_3:This inquiry looks for details regarding the software's versatility and customization options. Information on user interfaces, workflow configurations, and templates that can be customized to a clinic's specific needs and preferences may be included in the answers.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@VETERINARY_STORE.QUESTION_4:What type of assistance and training are available for setting up and utilising the software?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@VETERINARY_STORE.ANSWER_4:This inquiry relates to the software vendor's support and training offerings. In addition to providing clinics with access to instructional materials, webinars, and individualized support from a dedicated support team, the answers should outline the training resources, onboarding aid, and continuing support choices available to assist clinics in successfully implementing and using the software.`
          }
        }
      ]
    };

    this.addJsonLdToHead(faqSchema);
  }


  addJsonLdToHead(schema: any) {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'faq-schema';

    // Remove old schema if it exists
    const oldScript = document.getElementById('faq-schema');
    if (oldScript) {
      oldScript.remove();
    }

    this.renderer.appendChild(document.head, script);
  }

  countrychange(){

    this.mainservice.getMobileCode(this.enquiryForm.get('countryname1').value).subscribe((data)=>{
      //console.log(data);
      this.dialcode=data.Dailingcode;
      console.log(this.dialcode);
     // this.registerForm.get('phonedialcode').patchValue(this.dialcode[1]);
    })
  }
  checkCaptcha(){

    var usercaptcha = this.enquiryForm.get('enteredcaptcha').value

    if (this.captcha == usercaptcha) {
      this.ecaptcha = false

    } else {

      this.errorcaptcha = 'Enter correct Captcha'
      this.ecaptcha = true
    }
  }
  generatecaptcha(){
    this.mainservice.generatecaptcha()
    this.captcha = localStorage.getItem('captcha')
  }
  closeModal(): void {
    this.ngxsmartservice.close('enquirypos');
    this.ngxsmartservice.close('appointmentform');
    this.enquiryForm.reset();

    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  }
  validation(){
    let name=this.enquiryForm.get('leadname').value
    let organizationname=this.enquiryForm.get('organizationname').value
    let primaryemail=this.enquiryForm.get('primaryemail').value
    let primaryphone=this.enquiryForm.get('primaryphone').value
    let captcha=this.enquiryForm.get('enteredcaptcha').value
    let checkbox=this.enquiryForm.get('checkbox').value

    // var usercaptcha = this.registerForm.get('enteredcaptcha').value
    if(!name){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!organizationname){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Organization Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryemail){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Email',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryphone){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Mobile Number',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(captcha != this.captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Correct Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(checkbox==false){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Select Accept & Terms condition',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }


    return true
  }
  slectdate(event: any){
    this.showElement=true;
    const selectedDate = event.value;
    const finalDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.enquiryForm.get('appointmentdate').setValue(finalDate);
   this.currentTime = new Date();

   let map={
    "timezone":this.timezone,
    "orginaltimezone":this.currentTime
  }
  this.mainservice.gettimeSlots(map).subscribe(data=>{
    this.timeSlots = data[0].map((time:any)=> {
      const [hours, minutes] = time.split(':');
      const hours12 = ((parseInt(hours) + 11) % 12) + 1;
      const ampm = parseInt(hours) < 12 ? 'AM' : 'PM';
      return `${hours12}:${minutes} ${ampm}`;
    });
    this.showElement=false;
    console.log(this.timeSlots);
  })

    this.appointment_time=true;
  }
  selectTime(time: string): void {
    const currentTime = new Date();
    const formattedTime = this.datePipe.transform(currentTime, 'hh:mm:ss a');
    console.log(formattedTime);
    this.selectedTime = time;
    // this.enquiryForm.get('apptotime').setValue(time);
    this.enquiryForm.get('appfrmtime').setValue(time);

  }
  savelead(){
    this.showElementsave=true;



    // if (valid) {

      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

  this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();
      this.showElementsave=false;
      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.close('appointmentform');
      this.enquiryForm.reset();
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      // this.showElement=false;
    }
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  })

  }
  appointment(datasource:any){
    this.enquiryForm.get('sourceRef1').setValue(datasource);
    this.ngxsmartservice.open('enquirypos');
    // this.ngxsmartservice.open('appointmentform');
  }
  submitenquery(){
    let valid=this.validation();
    if(valid){
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.open('appointmentform');
      this.picker.open();
      this.inputField.focus();
    }

  }
}
